import React from 'react'
import { Tabs } from 'react-bootstrap'

/**
 * @param {{
 *    id: string
 *    defaultActiveKey: string
 * }} props
 * @returns {React.Component}
 */
const ZariTabs = ({ defaultActiveKey, id, ...props }) => {
  return <Tabs defaultActiveKey={defaultActiveKey} id={id} {...props} />
}

export default ZariTabs
